import { Anchor, Badge, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import {
  IconAward,
  IconBoxSeam,
  IconBrandAndroid,
  IconBrandApple,
  IconBrandChrome,
  IconChartLine,
  IconHistory,
  IconInbox,
  IconMail,
} from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import PushNotificationsStats from './PushNotificationsStats';

const PushNotificationsCards = ({ pushNotifications, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const domainCurrency = currentDomain.currency;
  const location = useLocation();
  const { accountId, domainId } = useParams();

  return pushNotifications.map((pushNotification) => (
    <Card key={pushNotification.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Flex align="center" gap="sm" mb="xs">
              <Anchor href={`#${location.pathname}/${pushNotification.id}/details`} fw={600}>
                {pushNotification.name}
              </Anchor>
            </Flex>
            <Flex gap="xs" wrap="wrap">
              {pushNotification.platforms.includes('web') && (
                <Badge variant="default">
                  <IconBrandChrome size={14} style={{ verticalAlign: 'middle' }} /> Web
                </Badge>
              )}
              {pushNotification.platforms.includes('android') && (
                <Badge variant="default">
                  <IconBrandAndroid size={14} style={{ verticalAlign: 'middle' }} /> Android
                </Badge>
              )}
              {pushNotification.platforms.includes('ios') && (
                <Badge variant="default">
                  <IconBrandApple size={14} style={{ verticalAlign: 'middle' }} /> IOS
                </Badge>
              )}
              {pushNotification.platforms.includes('appInbox') && (
                <Badge variant="default">
                  <IconInbox size={14} style={{ verticalAlign: 'middle' }} /> App Inbox
                </Badge>
              )}
              <Badge variant="default">
                {pushNotification.type === 'recommender' ? (
                  <IconAward size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                ) : (
                  <IconMail size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                )}
                {prettifiedLabel(pushNotification.type)}
              </Badge>
              {pushNotification.type === 'recommender' && pushNotification.productFeed && (
                <Badge variant="default">
                  <IconBoxSeam size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  <Anchor
                    href={`#/accounts/${accountId}/domains/${domainId}/productFeeds/${pushNotification.productFeed.id}/details`}
                    target="_blank"
                    size="xs"
                  >
                    {pushNotification.productFeed.name}
                  </Anchor>
                </Badge>
              )}
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(pushNotification.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(pushNotification.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${pushNotification.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <PushNotificationsStats
            stats={stats}
            pushNotification={pushNotification}
            period={period}
            currency={domainCurrency}
          />
        </Grid>
      </Card.Section>
    </Card>
  ));
};

export default PushNotificationsCards;
